export default function vitalConversion(vital) {
    // Convert celsius to fahrenheit
	if (vital.type.startsWith('vital:body_temperature')) {
        if (vital.unit == 'c')
            vital.unit = 'f'
        return (vital.unit == 'c') ? (vital.value * 1.8 + 32) : vital.value
    }
    if (vital.type.startsWith('vital:body_weight')) {
        if (vital.unit == 'kg')
            vital.unit = 'lb'
        return vital.value * ((vital.unit == 'kg') ? 2.20462 : 1);
    }
    if (vital.type.startsWith('vital:blood_pressure') && ! Array.isArray(vital.value)) {
        return [ (vital.value >> 16) & 0xff, vital.value & 0xff ]
    }
    if (vital.type.startsWith('vital:stress'))
        return vital.value
    if (vital.type.startsWith('vital:blood_glucose'))
        return vital.value
    if (vital.type.startsWith('vital:heart_rate'))
        return vital.value
	if (vital.type.startsWith('vital:sleep'))
		return vital.value
	if (vital.type.startsWith('vital:mood'))
		return vital.value
    return null
}
